(function() {
  'use strict';
  angular
    .module('app.shared')
    .controller('EditCareerController', EditCareerController);

  EditCareerController.$inject = [
    'APP_CONSTANTS',
    '$scope',
    'selectedCareer',
    '$uibModalInstance'
  ];

  function EditCareerController(
    APP_CONSTANTS,
    $scope,
    selectedCareer,
    $uibModalInstance
  ) {
    var vm = this;

    vm.loading = {};
    vm.careerDetails = {};
    vm.newLanguageVariation = {};
    vm.dismissModal = dismissModal;
    vm.selectedCareer = selectedCareer;
    vm.careersLanguageVariationArray = [];
    vm.saveUpdatedCareer = saveUpdatedCareer;
    vm.getLanguageVariations = getLanguageVariations;

    vm.selectedCareerName = _.get(
      selectedCareer,
      'variations.en.name',
      APP_CONSTANTS.occupation
    );

    getLanguageVariations();

    function dismissModal() {
      $uibModalInstance.dismiss();
    }

    function saveUpdatedCareer() {
      var editableFields = {};

      Object.keys(vm.careersLanguageVariation).forEach(function(key) {
        editableFields[key] = {};
        editableFields[key].description =
          vm.careersLanguageVariation[key].description;
        editableFields[key].name = vm.careersLanguageVariation[key].name;
        editableFields[key].socname = vm.careersLanguageVariation[key].socname;
        editableFields[key].description =
          vm.careersLanguageVariation[key].description;
        editableFields[key].shortDescription =
          vm.careersLanguageVariation[key].shortDescription;
        editableFields[key].descriptionUrl =
          vm.careersLanguageVariation[key].descriptionUrl;
        editableFields[key].duration =
          vm.careersLanguageVariation[key].duration;
        editableFields[key].educationalRequirementName =
          vm.careersLanguageVariation[key].educationalRequirementName;
        editableFields[key].Values = vm.careersLanguageVariation[key].Values;
      });

      $scope.$parent.vm.updateUnpublishedCareers(vm.selectedCareer.id);
      $scope.$parent.vm.updateExistingVariationInCareer(
        vm.selectedCareer.id,
        editableFields,
        vm.careerDetails
      );

      dismissModal();
    }

    function getLanguageVariations() {
      var alreadyUnpublishedCareer = $scope.$parent.vm.getUnpublishedCareerIfExist(
        vm.selectedCareer.id
      );

      if (alreadyUnpublishedCareer)
        vm.selectedCareer = JSON.parse(
          JSON.stringify(alreadyUnpublishedCareer)
        );

      vm.careerDetails = {
        alternateId: vm.selectedCareer.alternateId,
        soc: vm.selectedCareer.soc,
        medianPay: vm.selectedCareer.medianPay,
        jobOutlook: vm.selectedCareer.jobOutlook,
        educationalRequirementID: vm.selectedCareer.educationalRequirementID
      };

      vm.careersLanguageVariation = JSON.parse(
        JSON.stringify(vm.selectedCareer.variations)
      );

      Object.keys(vm.careersLanguageVariation).forEach(function(key) {
        vm.careersLanguageVariationArray.push({
          name: APP_CONSTANTS.languageVariations[key],
          variation: vm.careersLanguageVariation[key]
        });
      });
    }
  }
})();
